export default __webpack_public_path__ + "static/media/adobexd-logo.bb801ac7.svg";